import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { Button } from '../ui/button';

export interface SessionWarningDialogProps {
  isOpen: boolean;
  msUntilLogout: number;
  onStaySignedIn: () => void;
  onSignOut: () => void;
}

function formatTimeRemaining(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes <= 0) {
    return `${seconds} second${seconds === 1 ? '' : 's'}`;
  }
  return `${minutes} minute${minutes === 1 ? '' : 's'} ${seconds.toString().padStart(2, '0')}s`;
}

export function SessionWarningDialog({
  isOpen,
  msUntilLogout,
  onStaySignedIn,
  onSignOut,
}: SessionWarningDialogProps) {
  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Your session is about to expire</AlertDialogTitle>
          <AlertDialogDescription>
            You will be signed out in {formatTimeRemaining(msUntilLogout)} due to inactivity. Click
            &ldquo;Stay signed in&rdquo; to continue.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onSignOut}>
            Sign out
          </Button>
          <Button onClick={onStaySignedIn}>Stay signed in</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
